<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0">
            <router-link
              to="/startup/chamadas"
              class="btn-link font-weight-normal text-white"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-lg-5">
          <card shadow type="secondary" class="text-center">
            <div class="card-profile-image">
              <img
                v-if="startup.logo"
                :src="startup.logo.url"
                class="card-image my-3"
                alt="..."
              />
            </div>
            <div class="card-body mt-9 py-0">
              <h2 class="card-title text-orange mb-1">
                {{ startup.name }}
              </h2>
              <div>
                <div class="h5 font-weight-300 mb-1">
                  <i class="ni ni-pin-3 mr-2"></i>{{ startup.city || "..." }},
                  {{ startup.state || "..." }}
                </div>
                <p class="ml-2 text-sm mt-3">
                  <i class="fas fa-quote-left mr-2"></i
                  >{{ startup.one_sentence_pitch
                  }}<i class="fas fa-quote-right ml-2"></i>
                </p>
                <div
                  class="h5 font-weight-300 mb-1"
                  v-if="startup.subscription"
                >
                  <i class="fas fa-user-tie mr-1"></i> Responsável:
                  {{ startup.subscription.responsible_name }}
                </div>
              </div>
              <hr class="my-4" />
              <div v-if="startup.subscription" class="text-left">
                <div>
                  <h6 class="heading-small text-muted mb-4">Sobre a startup</h6>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Setor(es) econômico(s) de
                    atuação:
                    <span class="text-muted">
                      {{ startup.sector }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Data de fundação:
                    <span class="text-muted">
                      {{ formatDate(startup.foundation) }}
                    </span>
                  </p>
                  <div class="mb-3" v-if="startup.subscription.startup_problem">
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Desafios mais
                      significativos:
                      <span class="text-sm text-muted">
                        {{ startup.subscription.startup_problem }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="startup.subscription.how_can_stars_help"
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Como a Stars pode
                      ajudar?
                      <span class="text-sm text-muted">
                        {{ startup.subscription.how_can_stars_help }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="startup.subscription.responsible_phone"
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Celular do responsável:
                      <span class="text-sm text-muted">
                        {{ startup.subscription.responsible_phone }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="startup.subscription.responsible_email"
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> E-mail do responsável:
                      <span class="text-sm text-muted">
                        {{ startup.subscription.responsible_email }}
                      </span>
                    </p>
                  </div>
                  <div class="mb-3" v-if="startup.bussiness_strategy">
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Em qual mercado
                      principal sua startup pretende atuar?
                      <span class="text-sm text-muted">
                        {{ startup.bussiness_strategy }}
                      </span>
                    </p>
                  </div>
                  <div class="mb-3" v-if="startup && startup.stage">
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Qual estágio a startup
                      está atualmente?
                      <span class="text-sm text-muted">
                        {{ startup.stage }}
                      </span>
                    </p>
                  </div>
                 
                <hr class="my-4" />
                <div>
                  <h6 class="heading-small text-muted mb-4">Negócio</h6>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Maior vantagem
                    competitiva:
                    <span class="text-muted">
                      {{ startup.subscription.product_competitive_advantage }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Modelo de negócios:
                    <span class="text-muted">
                      {{ startup.subscription.product_bussiness_strategy }}
                    </span>
                  </p>
                  <!-- <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Faturamento total do
                    último ano (em reais):
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.last_year_revenue }}
                    </span>
                  </p> -->
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Faturamento total do
                    último trimestre (em reais):
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.last_quarters_revenue }}
                    </span>
                  </p>
                   <div
                    class="mb-3"
                    v-if="
                      startup.subscription &&
                      startup.subscription.product_market_cap
                    "
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Qual o tamanho de
                      mercado? (opcional)
                      <span class="text-sm text-muted">
                        {{ startup.subscription.product_market_cap }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="
                      startup.subscription &&
                      startup.subscription.active_clients
                    "
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Quantos clientes ativos
                      a startup possui atualmente?
                      <span class="text-sm text-muted">
                        {{ startup.subscription.active_clients }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="
                      startup.subscription &&
                      startup.subscription.already_participated_batch
                    "
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> A startup já participou
                      da seleção em outro Batch da Stars? Caso sim, quando?
                      <span class="text-sm text-muted">
                        {{ startup.subscription.already_participated_batch }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="
                      startup.subscription &&
                      startup.subscription.investment_sought
                    "
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Qual o valor de
                      investimento que a startup busca?
                      <span class="text-sm text-muted">
                        {{ startup.subscription.investment_sought }}
                      </span>
                    </p>
                  </div>
                  <div
                    class="mb-3"
                    v-if="
                      startup.subscription &&
                      startup.subscription.equity_offered
                    "
                  >
                    <p class="text-sm mb-1">
                      <i class="fas fa-arrow-right"></i> Qual o percentual de
                      equity oferecido? (máximo de 100%)
                      <span class="text-sm text-muted">
                        {{ startup.subscription.equity_offered }}%
                      </span>
                    </p>
                  </div>
                </div>
                  <!-- <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Faturamento total do
                    último mês (em reais):
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.last_month_revenue }}
                    </span>
                  </p> -->
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Problema ou necessidade
                    resolvida pela empresa:
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.product_market_problem }}
                    </span>
                  </p>
                  <p class="text-sm">
                    <i class="fas fa-arrow-right"></i> Captable atual:
                    <span class="text-muted" style="white-space: pre-line">
                      {{ startup.subscription.startup_equity }}
                    </span>
                  </p>
                  <p class="text-sm mb-1">
                    <i class="fas fa-arrow-right"></i> Website:
                    <span a class="text-muted text-sm mb-0">
                      {{ getWebsiteUrl() }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-7 mt-3 mt-lg-0">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">
                    <span class="text-warning">{{
                      startup.name || "Startup"
                    }}</span>
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-12">
              <h6 class="heading-small text-muted mb-4">
                <i class="fab fa-youtube mr-2"></i> Pitch vídeo
              </h6>
              <div class="video-wrap text-center">
                <div
                  class="video-container"
                  v-if="
                    startup.subscription &&
                    startup.subscription.startup_pitch_video_youtube_id
                  "
                >
                  <iframe
                    :src="
                      getUrl(
                        startup.subscription.startup_pitch_video_youtube_id
                      )
                    "
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  >
                  </iframe>
                </div>
                <badge v-else type="info" class="mb-3">
                  Pitch vídeo não encontrado
                </badge>
              </div>
            </div>
            <hr class="my-4" />
            <div class="col-12">
              <h6 class="heading-small text-muted mb-4">
                <i class="far fa-file-pdf mr-2"></i> Pitch deck
                <a
                  v-if="startup.subscription && startup.subscription.deck"
                  :href="startup.subscription.deck.url"
                  target="_blank"
                  class="btn btn-sm btn-primary float-right"
                >
                  <i class="fas fa-file-download"></i> Baixar
                </a>
              </h6>
              <div class="row mt-3">
                <div class="col text-center">
                  <div v-if="startup.subscription && startup.subscription.deck">
                    <pdf
                      style="margin: 0 auto; width: 90%; max-width: 700px"
                      ref="startupDeck"
                      :src="startup.subscription.deck.url"
                      :page="deck.page"
                      @num-pages="deck.pageCount = $event"
                      @page-loaded="deck.currentPage = $event"
                    ></pdf>
                    <div class="text-center mt-2">
                      <base-button
                        :iconOnly="true"
                        icon="fa fa-chevron-left"
                        size="sm"
                        class="mr-0"
                        @click="previousPage()"
                        :disabled="this.deck.page <= 1"
                      ></base-button>
                      <span class="mx-3 text-sm"
                        >{{ deck.currentPage }} / {{ deck.pageCount }}</span
                      >
                      <base-button
                        :iconOnly="true"
                        icon="fa fa-chevron-right"
                        size="sm"
                        class="mr-0"
                        @click="nextPage()"
                        :disabled="this.deck.page >= this.deck.pageCount"
                      ></base-button
                      >`
                    </div>
                  </div>
                  <div v-else>
                    <badge type="info" class="mb-3">
                      Pitch deck não encontrado
                    </badge>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api.js";
import pdf from "vue-pdf";

export default {
  name: "inscricao-view",
  components: {
    pdf,
  },
  data() {
    return {
      startup: "",
      error: "",
      deck: {
        page: 1,
        currentPage: 0,
        pageCount: 0,
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      width: 140,
      height: 140,
    });
    try {
      const { data: startup } = await api.get(
        `/startup-call-subscriptions/${this.$route.params.id}`
      );
      startup.subscription.product_own_technology = Boolean(
        startup.subscription.product_own_technology
      );
      startup.subscription.startup_is_incubated = Boolean(
        startup.subscription.startup_is_incubated
      );

      const translatedStage = {
        concept: "Ideação",
        validation: "Validação",
        traction: "Tração",
        scale: "Escala",
        other: "Outro",
      };

      if (startup && startup.stage) {
        startup.stage = translatedStage[startup.stage] || "Outro";
      } else {
        startup.stage = "Não informado";
      }

      try {
        const links = JSON.parse(startup.subscription.product_more_information);
        if (Array.isArray(links)) {
          startup.subscription.product_more_information = links
            .map((link) => (link && link.link ? link.link : ""))
            .filter((link) => link && link.trim() !== "");
        } else if (links && links.link) {
          startup.subscription.product_more_information = [links.link];
        } else {
          startup.subscription.product_more_information = [];
        }
      } catch (e) {
        startup.subscription.product_more_information =
          startup.subscription.product_more_information &&
          startup.subscription.product_more_information.trim() !== ""
            ? [startup.subscription.product_more_information]
            : [];
      }
      const defaultLogoPath = "/img/pages/default_logo.png";
      if (!startup.logo) startup.logo = { url: defaultLogoPath };
      this.startup = startup;
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
      this.$router.push(`/startup/chamadas`);
    }
    loader.hide();
  },
  methods: {
    getWebsiteUrl() {
      if (
        !this.startup.subscription ||
        !this.startup.subscription.product_more_information
      ) {
        return "não informado";
      }

      const productInfo = this.startup.subscription.product_more_information;

      if (Array.isArray(productInfo)) {
        const firstItem = productInfo[0];
        if (!firstItem || firstItem === "" || firstItem === "undefined") {
          return "não informado";
        }
        return firstItem;
      }

      if (typeof productInfo === "string") {
        try {
          const parsed = JSON.parse(productInfo);
          if (parsed && parsed.link && parsed.link.trim() !== "") {
            return parsed.link;
          }
          return "não informado";
        } catch (e) {
          return productInfo && productInfo.trim() !== ""
            ? productInfo
            : "não informado";
        }
      }

      return "não informado";
    },
    getUrl(youtubeVideoId) {
      return `https://www.youtube.com/embed/${youtubeVideoId}`;
    },
    nextPage() {
      if (this.deck.pageCount > this.deck.page) this.deck.page++;
    },
    previousPage() {
      if (this.deck.page > 1) this.deck.page--;
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 180px;
  height: 180px;
  border-radius: 10%;
  margin: auto;
}
.video-container {
  position: relative;
  overflow: hidden;
  height: 0;
  padding-bottom: 50%;
}

.video-container iframe,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.video-wrap {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}
</style>
